/**
 * Space above a level surface so top/left/right clearance match the `px-1` side inset (4px).
 * Used as list content padding at rest, and as the extra `viewOffset` when jumping the active
 * level under the grade tabs. Sticky headers still pin flush. The opaque grade tabs sit between
 * the header fade and the list, so the list suppresses the fade's clearance (`suppressContentGap`)
 * and this is the whole gap.
 */
export const LEVELS_LIST_TOP_GAP = 4;
